<template>
  <div class="main-head-activity" v-show="isShow" v-loading="loading">
    <div>
      <div class="activity-head">
        <img src="../../../../assets/activity/activity_head.png" alt="">
      </div>
      <!-- 直接跳转 -->
      <router-link :to="{ name : 'NewYearList', params : {token:queryParams.token}}">
        <div class="activity-list-button-css" style="margin-right: 0.5%;" ></div>
      </router-link>
      <div class="activity-background-top-css" style="position: absolute;top:6.3rem">
        <p class="aty-to-context">新年和往常一样，愿望也不一定非要在过年期盼，唯有一些特别的人，他们用心告诉你：我又陪了你一年。</p>
        <div>
          <div v-for='(item,index) in rewardList'>
            <div class="activity-gift-css"
                 :style="{'margin-top':(index<=2)? 1.7+'rem':0.6+'rem' ,'margin-left':(index===3)? 14+'%':'', 'margin-bottom':(index<=2)? '':8+'px', 'width':(index<=2)? 32+'%':36+'%'}">
              <div style="z-index:2;position: relative;right:0;margin:auto;">
                <div style="position: absolute;">
                  <div style="position: absolute;">
                    <img class="activity-pond-name-gift-img"   :style="{'height':(index<=2)? 2.2+'rem':2.6+'rem','margin-left':(index<=2)? 0.2+'rem':0.2+'rem'}"
                         :src="item.image_url"
                         alt="">
                  </div>
                </div>
                <div style="position: absolute;z-index: 2;top: 1.9rem;"  >
                  <div class="activity-pond-gift-name" style="position: absolute;z-index: 2"   :style="{'margin-left':(index<=2)? '':0.2+'rem','margin-top':(index<=2)? '':0.3+'rem'}" > {{ item.name }}</div>
                  <div class="activity-background-price" style="position: absolute;" :style="{'margin-left':(index<=2)? '':0.3+'rem','margin-top':(index<=2)? 0.1+'rem':0.4+'rem'}">
                    {{ item.price }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="activity-background-bottom-css" style="position: absolute;top:19rem">
        <p
          style="color: rgba(232, 17, 17, 100);font-size: 0.5rem;font-weight: bold; position: absolute;left: 5%;right: 0;top: 1.5rem;margin: auto;">
          活动时间：</p>
        <p
          style="color: rgba(252, 70, 36, 100);font-size: 0.45rem;font-weight: 500; position: absolute;left: 22%;right: 0;top: 2.5rem;margin: auto;">
          2022年1月30-2月6号</p>
        <p
          style="color: rgba(232, 17, 17, 100);font-size: 0.5rem;font-weight: bold; position: absolute;left: 5%;right: 0;top: 3.5rem;margin: auto;">
          玩法介绍：</p>
        <p
          style="color: rgba(252, 70, 36, 100);font-size: 0.4rem;font-weight: bold; position: absolute;left: 0;right: 0;top: 4.5rem;margin: auto;width: 84%">
          新年活动期间送出或收到以上5种礼物即可累计相应的积分，进入排行榜就可领取丰厚奖励！【规则如下】</p>
        <p
          style="color: rgba(252, 70, 36, 100);font-size: 0.4rem;font-weight: bold; position: absolute;left: 0;right: 0;top: 6.5rem;margin: auto;width: 84%">
          1、所有用户均可参与，在聊天界面送出指定礼物即可累计积分排名。<br>
          2、礼物红人榜=活动期间女性在聊天界面收到男性指定礼物的积分排名。<br>
          3、礼物神豪榜=活动期间男性在聊天界面赠送女性指定礼物的积分排名。<br>
          4、所有奖励均无需手动领取，平台会在活动结束后1个工作日内自动发放。</p>
        <p
          style="color: rgba(232, 17, 17, 100);font-size: 0.5rem;font-weight: bold; position: absolute;left: 5%;right: 0;top: 11.2rem;margin: auto;">
          活动奖励：</p>
        <p
          style="color: rgba(252, 70, 36, 100);font-size: 0.4rem;font-weight: 500; position: absolute;left: 22%;right: 0;top: 12rem;margin: auto;">
          第一名：奖励88888宝石</p>
        <p
          style="color: rgba(252, 70, 36, 100);font-size: 0.4rem;font-weight: 500; position: absolute;left: 22%;right: 0;top: 12.7rem;margin: auto;">
          第二名：奖励58888宝石</p>
        <p
          style="color: rgba(252, 70, 36, 100);font-size: 0.4rem;font-weight: 500; position: absolute;left: 22%;right: 0;top: 13.4rem;margin: auto;">
          第三名：奖励28888宝石</p>
        <p
          style="color: rgba(252, 70, 36, 100);font-size: 0.4rem;font-weight: 500; position: absolute;left: 22%;right: 0;top: 14.1rem;margin: auto;">
          第四至十名：奖励10000宝石</p>
      </div>
      <div style="opacity: 0.8;color:rgba(255, 255, 255, 100);font-size: 0.35rem;text-align: center;font-family: SourceHanSansSC-Medium;position: relative;top: 35.5rem">
        本活动最终解释权归官方所有
      </div>

    </div>
  </div>

</template>
<script>
import {isError} from '../../../../api/activity/activity'

export default {
  name: 'HappyNewYear',
  data() {
    return {
      //当前选项卡的索引
      currentIndex: 0,
      // 遮罩层
      loading: true,
      //规则弹框
      ruleDialog: false,
      //参数
      queryParams: {
        sex: 2,
        type: 4,
        token: ""
      },
      isShow: false,
      windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
      rewardList: [
        {
          id: 1,
          type: 1,
          price: '288积分',
          name: '新年红包',
          image_url: require("../../../../assets/activity/gift/specific/red_envelopes.png"),
        },
        {
          id: 2,
          type: 1,
          price: '888积分',
          name: '新年鞭炮',
          image_url: require("../../../../assets/activity/gift/specific/firecrackers.png"),
        },
        {
          id: 3,
          type: 1,
          price: '5888积分',
          name: '招财虎',
          image_url: require("../../../../assets/activity/gift/specific/fortune_tiger.png"),
        },
        {
          id: 4,
          type: 1,
          price: '12888积分',
          name: '新春快乐',
          image_url: require("../../../../assets/activity/gift/specific/happy_new_year.png"),
        },
        {
          id: 5,
          type: 1,
          price: '38888积分',
          name: '新年陪伴',
          image_url: require("../../../../assets/activity/gift/specific/new_year_together.png"),
        },
      ],
      //榜单列表
      midAutumnList: [],
      //我的榜单信息
      myDataPojo: {},
      avatar: "../../../../assets/valentine/test.jpeg",
    }

  },
  mounted: function () {
    this.getToken()
    this.isError()
    // this.getData()
  },
  // 方法
  methods: {
    change: function (index) {
      if (this.currentIndex != index) {
        this.currentIndex = index;
        if (this.currentIndex === 0) {
          this.queryParams.sex = 2
        } else {
          this.queryParams.sex = 1
        }
        this.getData()
      }
    },

    getToken() {
      this.queryParams.token = window.android.getToken();
      // this.queryParams.token = "eyJ0eXAiOiJKc29uV2ViVG9rZW4iLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiIyMDAxMyIsInNleCI6IjEiLCJjcmVhdGVEYXRlIjoxNjExNzk1LCJpc3MiOiJhZG1pbiIsImV4cCI6MTYyNzM0Nzk0NywibmJmIjoxNjExNzk1fQ.xfKchleKjuT0Wf-GWgZOALRlv0637-VMIJ1K3D8C7zk"
      // this.queryParams.token = "eyJ0eXAiOiJKc29uV2ViVG9rZW4iLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiIyMDAwNyIsInNleCI6IjEiLCJjcmVhdGVEYXRlIjoxNjExNzU4LCJpc3MiOiJhZG1pbiIsImV4cCI6MTYyNzMxMDU4MiwibmJmIjoxNjExNzU4fQ.vuIdxVPLdT8s0DPNib89012cO__ttsFQOboFkC6tQxY"
    },

    //是否显示
    isError() {
      this.loading = true
      isError(this.queryParams).then(response => {
        if (response.data) {
          this.isShow = true
        } else {
          this.bus.$emit('tips', {
            show: true,
            title: '系统出现异常，请及时联系管理员!'
          })
        }
      })
      this.loading = false
    },
  },

}

</script>

<style type="text/css">

</style>



// WEBPACK FOOTER //
// src/view/pomelo/app/newYear/index.vue